import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import { EndpointKeysCommon } from '../../constants/utils/app.constants';
import { ClosestAirportCode } from '../../models/geo-location/geo-location.interface';
import { ApiBuilder, AppConfigService, LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {
  constructor(
    private appConfig: AppConfigService,
    private logging: LoggingService,
    private http: HttpClient
  ) {}

  closestAirportCode$!: Observable<ClosestAirportCode>;

  getClosestAirportCode$(): Observable<ClosestAirportCode> {
    if (this.closestAirportCode$) {
      return this.closestAirportCode$;
    } else {
      this.closestAirportCode$ = this.getClosestAirportCode().pipe(
        shareReplay(1)
      );
      return this.closestAirportCode$;
    }
  }

  getClosestAirportCode(): Observable<ClosestAirportCode> {
    return new ApiBuilder<string, ClosestAirportCode>(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon['GET_CLOSEST_DELTA_AIRPORT_CODE'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this._handleError.bind(this))
      .library('SEARCH_FLIGHTS')
      .create();
  }

  private _handleError(error: HttpErrorResponse): Observable<never> {
    this.logging.log(error.message);
    return throwError(error);
  }
}
